import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "@/i18n/en.yaml";

Vue.use(VueI18n);

let messages = {};

messages = { ...messages, en };

const lang = localStorage.getItem("language") || "en";

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: "en",
  messages,
});

export default i18n;
